import { Link, useNavigate, useParams } from '@tanstack/react-router';
import { toast } from 'sonner';
import type { PropertyInput } from '@app/shared';
import { PropertyForm } from '@/features/properties/PropertyForm';
import { useProperty, useUpdateProperty } from '@/features/properties/queries';
import { apiErrorMessage } from '@/lib/api';

export function EditPropertyPage() {
  const { propertyId } = useParams({ strict: false }) as { propertyId: string };
  const id = Number(propertyId);
  const navigate = useNavigate();
  const property = useProperty(id);
  const updateProperty = useUpdateProperty(id);

  if (property.isPending) return <p className="text-muted-foreground">Chargement…</p>;
  if (property.isError || !property.data) return <p className="text-destructive">Bien introuvable.</p>;

  const defaultValues: PropertyInput = {
    name: property.data.name,
    kind: property.data.kind,
    usage: property.data.usage,
    country: property.data.country,
    currency: property.data.currency,
    address: property.data.address,
    postalCode: property.data.postalCode,
    city: property.data.city,
    surfaceM2: property.data.surfaceM2,
    rooms: property.data.rooms,
    acquiredOn: property.data.acquiredOn,
    notes: property.data.notes,
  };

  return (
    <div className="flex flex-col gap-6">
      <Link
        to="/biens/$propertyId"
        params={{ propertyId }}
        className="text-sm text-muted-foreground hover:underline"
      >
        ← Retour au bien
      </Link>
      <h1 className="text-2xl font-semibold">Modifier {property.data.name}</h1>
      <PropertyForm
        defaultValues={defaultValues}
        isPending={updateProperty.isPending}
        submitLabel="Enregistrer"
        onSubmit={(values) => {
          updateProperty.mutate(values, {
            onSuccess: () => {
              toast.success('Bien mis à jour');
              void navigate({ to: '/biens/$propertyId', params: { propertyId } });
            },
            onError: (error) => {
              toast.error(apiErrorMessage(error, 'Échec de la mise à jour'));
            },
          });
        }}
      />
    </div>
  );
}
